import "./styles.scss";

const SobreMim = () => {
  return (
    <div className="SobreMimConteiner">
      <div>
        <div className="SmItens">
          <div className="resume">
            Jovem desenvolvedor Full-stack apaixonado por tecnologia, formado em
            Análise e Desenvolvimento de Sistemas. Especializado em NextJS e Angular, com criatividade para criar interfaces envolventes. Amante
            de jogos e animes, busca unir paixão e conhecimento para entregar
            soluções inovadoras. Vamos criar juntos!
          </div>

          <div className="cursos">
            <h3>Cursos</h3>
            <ul>
              <li>
                Analise e Desenvolvimento de Sistemas
                <p className="ano">2021-2022</p>
                <p className="escola">UNICID</p>
              </li>
              <li>
                Design Gráfico
                <p className="ano">2019-2021</p>
                <p className="escola">SAGA</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SobreMim;
